import { createBrowserRouter } from "react-router";
import { PublicLayout } from "@/routes/public/layout";
import { LandingPage } from "@/routes/public/landing";
import { MerchantRequestPage } from "@/routes/public/merchant-request";
import { JobsPage } from "@/routes/public/jobs";
import { ApplyPage } from "@/routes/public/apply";
import { OpenApplicationPage } from "@/routes/public/open-application";
import { AdminLoginPage } from "@/routes/admin/login";
import { AdminLayout } from "@/routes/admin/layout";
import { AdminOverviewPage } from "@/routes/admin/overview";
import { AdminRequestsPage } from "@/routes/admin/requests";
import { AdminApplicationsPage } from "@/routes/admin/applications";
import { AdminCandidatesPage } from "@/routes/admin/candidates";
import { AdminRoleRailPage } from "@/routes/admin/role-rail";

function detectBasename() {
  const baseUrl = import.meta.env.BASE_URL;
  if (baseUrl && baseUrl !== "/" && baseUrl !== "./") {
    return baseUrl.replace(/\/$/, "") || undefined;
  }

  // Runtime fallback for production mounts that do not inject a build-time
  // base path. Keep the known /ngon deployment working without a custom build.
  if (
    typeof window !== "undefined" &&
    (window.location.pathname === "/ngon" || window.location.pathname.startsWith("/ngon/"))
  ) {
    return "/ngon";
  }

  return undefined;
}

const basename = detectBasename();

export const router = createBrowserRouter([
  {
    Component: PublicLayout,
    children: [
      { index: true, Component: LandingPage },
      { path: "hire", Component: MerchantRequestPage },
      { path: "jobs", Component: JobsPage },
      { path: "jobs/:id/apply", Component: ApplyPage },
      { path: "openapplication", Component: OpenApplicationPage },
    ],
  },
  { path: "admin/login", Component: AdminLoginPage },
  {
    path: "admin",
    Component: AdminLayout,
    children: [
      { index: true, Component: AdminOverviewPage },
      { path: "requests", Component: AdminRequestsPage },
      { path: "requests/:id", Component: AdminRequestsPage },
      { path: "applications", Component: AdminApplicationsPage },
      { path: "applications/:id", Component: AdminApplicationsPage },
      { path: "candidates", Component: AdminCandidatesPage },
      { path: "candidates/:id", Component: AdminCandidatesPage },
      { path: "role-rail", Component: AdminRoleRailPage },
      { path: "role-rail/:id", Component: AdminRoleRailPage },
    ],
  },
], { basename });
